// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const LoanActivationService = {};

function buildQuery(params) {
  return Object.entries(params)
    .filter(([_, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}

LoanActivationService.getLoanActivationService = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;

  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    loanNo: data?.loanNo,
    customerName: data?.customerName,
    branchId: data?.branchId,
  };
  return lossClient({
    url: `/LoanActivation/search?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

LoanActivationService.addLoanActivationService = function (data) {
  return lossClient({
    url: `/LoanActivation/add`,
    method: "post", 
    data: data?.data,
  });
};

export default LoanActivationService;
